<template lang="jade">
  div
    input(type="file"
          v-el:upload
          @change="fileHandler"
          style="display: none"
          multiple)
    div.Button-group
      div.Button.Button--primary(v-for="btn in buttons"
                                 type="button"
                                 ":skin"="skins.buttons"
                                 ":text"="btn.text"
                                 @click="btn.evt")
        span.Button__text {{ btn.text }}
    div.Dropzone(droppable="true"
                 v-on:dragover="dragover"
                 v-on:drop="fileHandler")
      div.Dropzone__backdrop(v-if="!files.length")
        i(class="Dropzone__icon fa fa-cloud-upload fa-2x"
          aria-hidden="true")
        span.Dropzone__text Drop files here to upload
      div.File(v-for="file in files")
        header.File__header
          h5.File__title(:title="file.meta.name") {{ file.meta.name | format }}
        div.File__body
          div.File__icon
            i.fa.fa-file-o.fa-3x
          div.File__size {{ file.meta.size / 1000 }}.kb
          progress.File__progress(max="100" value="0")
        Footer.File__footer
          button.File__btn(type="button"
                           @click="upload($index)")
            span.fa.fa-cloud-upload
          button.File__btn(type="button"
                           @click="remove($index)")
            span.fa.fa-trash-o
</template>

<script>
import { forms, skins } from 'src/vuex/getters.js'
import { Asset } from 'src/services/resources'
import _ from 'lodash'

export default {
  data () {
    return {
      files: [],
      columns: ['Name', 'Content Type', 'Size', 'Actions'],
      buttons: [
        { text: 'Add files',
          evt: this.fileUploadTrigger },
        { text: 'Upload',
          evt: this.upload },
        { text: 'Cancel',
          evt: null },
        { text: 'Clear',
          evt: this.clear }
      ]
    }
  },
  props: {
    fdata: {
      type: Object,
      required: true
    }
  },
  vuex: {
    getters: {
      forms,
      skins
    }
  },
  filters: {
    format (str) {
      return str.split('.')[0].replace(/._|-/g, ' ')
    }
  },
  methods: {
    dragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
      return true
    },

    fileUploadTrigger () {
      this.$els.upload.click()
    },

    fileHandler (e) {
      e.stopPropagation()
      e.preventDefault()
      let fileList = e.target.files || e.dataTransfer.files
      let files = _.values(fileList).map(xs => {
        return { meta: xs,
                 complete: false,
                 progress: 0 }
      })
      this.$set('files', _.union(this.files, files))
    },

    upload (idx) {
      let data = new FormData()
      let field = this.fdata.field
      data.append('assetId', this.fdata.assetId)
      typeof idx !== 'number' ? this.files.forEach(xs => data.append(field + '[]', xs.meta))
                              : data.append(field, this.files[idx].meta)
      Asset.upload(data)
    },

    clear () {
      this.$set('files', [])
    },

    remove (idx) {
      this.files.splice(idx, 1)
    }

  },

  ready () {}

}
</script>



// WEBPACK FOOTER //
// upload.vue?cbed5c1a